import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useTutorial } from '@/features/onboarding/useTutorial';
import { usePwaInstall } from './usePwaInstall';
import { STORAGE_KEYS, PWA_INSTALL_PROMPT_DELAY_MS } from '@/config/appConfig';

export const InstallPromptSheet = () => {
  const { appUser, isFirstLogin } = useAuth();
  const { isActive: isTutorialActive } = useTutorial();
  const { canInstall, isStandalone, isAndroid, promptInstall } = usePwaInstall();
  const [delayElapsed, setDelayElapsed] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEYS.pwaInstallDismissed) === 'true'
  );

  useEffect(() => {
    const timer = setTimeout(() => setDelayElapsed(true), PWA_INSTALL_PROMPT_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEYS.pwaInstallDismissed, 'true');
    setDismissed(true);
  };

  const open =
    canInstall &&
    !isStandalone &&
    isAndroid &&
    !!appUser &&
    isFirstLogin === false &&
    !isTutorialActive &&
    !dismissed &&
    delayElapsed;

  const handleInstall = async () => {
    await promptInstall();
    dismiss();
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && dismiss()}>
      <DialogContent className="sm:max-w-md">
        <div className="text-center mb-2">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-orange-100">
            <Download className="h-7 w-7 text-orange-600" />
          </div>
          <DialogTitle className="text-xl font-bold text-gray-800 mb-2">
            Install Dr. Phyto
          </DialogTitle>
          <p className="text-sm text-gray-600">
            Add Dr. Phyto to your home screen for quick, full-screen access.
          </p>
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end mt-2">
          <button
            type="button"
            onClick={dismiss}
            className="w-full sm:w-auto px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
          >
            Not now
          </button>
          <button
            type="button"
            onClick={handleInstall}
            className="w-full sm:w-auto bg-orange-500 text-white py-2 px-4 rounded-lg hover:bg-orange-600 text-sm font-medium"
          >
            Install
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
